import React from 'react';
import keyBy from 'lodash.keyby';
import './drawer.css';
import styled, { css } from 'styled-components';
// import { OrderedMap } from 'immutable';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { openMonitorModal, closeMonitorModal } from '../../reducers/modals';
// import { setIsFirmwareUpload } from '../../reducers/mode';
// import VM from 'scratch-vm';
import {
    injectIntl,
    defineMessages,
    // intlShape 
} from 'react-intl';
// import MataMonitorList from '../../containers/mata-monitor-list.jsx';
// import extensionLibraryContent from '../../lib/libraries/extensions/index.jsx';
// import FirmwareUploadComponent from './firmwareUploadComponent.jsx';
// import SegmentedComponent from '../segmented/SegmentedComponent.jsx';
import handleShowIcon from './assets/handle-show.png';
import handleHiddenIcon from './assets/handle-hidden.png';
import { DrawerComponent } from './drawer';
import SegmentedRadio from './SegmentedRadio';
import CameraComponent from './cameraComponent';
import DeviceComponent from './deviceComponent';
import MonitorComponent from './monitorComponent';
// import Hardware from '../../containers/hardware.jsx';
import { setDrawerShowState, setIsFirmwareUpload } from '../store/drawer'

// const messages = defineMessages({
//     variable: {
//         defaultMessage: 'Variable', description: 'Variable', id: 'gui.monitorDrawer.variable'
//     },
//     upload: {
//         defaultMessage: 'Upload', description: 'Upload', id: 'gui.alerts.upload'
//     },
//     noMonitor: {
//         defaultMessage: 'No Monitor', description: 'No Monitor', id: 'gui.monitorDrawer.noMonitor'
//     },
//     noExtension: {
//         defaultMessage: 'No Extension', description: 'No Extension', id: 'gui.monitorDrawer.noExtension'
//     }
// });
const DrawerHandle = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: all;
    cursor: ew-resize;
    transition: width 0.5s ease-in-out, left 0.5s ease-in-out,
    right 0.5s ease-in-out;
    ${props => (props.isShow ? css`
        left: -34px;
    ` : css`
        left: -26px;
    `)}
`;

// 拖拽手柄
const WrapDrawerHandle = styled.div`
    pointer-events: none;
    position: relative;
    transition: margin-left 0.5s ease-in-out, margin-right 0.5s ease-in-out;
`;

const EmptyTips = styled.div`
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: #7c7c7c;
`;

class MonitorDrawerComponent extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, ['renderDragHandle', 'setSelectedValue', 'handleClick']);
        this.scRef = React.createRef();
        // this.s1 = React.createRef();
        // this.s2 = React.createRef();
        this.state = {
            selectedValue: 'device',
            list: [{
                number: 1
            }, {
                number: 2
            }],
            deviceState: false
        };
        // window.vm = this.props.vm;
    }

    componentDidUpdate(prevProps) {
        // console.log(prevProps, 9999)
        // 当monitors发生变化时，判断monitors长度，为1时展开抽屉，为0时关闭抽屉
        let preSize = 0;
        if (prevProps.monitors) {
            preSize = prevProps.monitors.filter(m => m.visible)
                .toList().size;
        }
        if (preSize === 0 && this.size === 1) {
            this.props.onShow();
            this.scRef.current.setActiveIndex('monitor');
            this.setState({
                selectedValue: 'monitor'
            });
            localStorage.setItem('drawerValue', 'monitor')
        } else if (preSize > 0 && this.size === 0) {
            // this.props.onClose();
        }
    }
    componentDidMount() {
        if (localStorage.getItem('drawerValue')) {
            setTimeout(() => {
                this.setFirmwareMode(localStorage.getItem('drawerValue'))
            }, 1);
        } else {
            this.props.onShow();
            this.setFirmwareMode(this.state.selectedValue)
        }
    }
    componentWillUnmount() {
    }

    get size() {
        // return this.props.monitors.filter(m => m.visible)
        //     .toList().size;
    }

    get extensions() {
        const extensionLibraryThumbnailData = keyBy(extensionLibraryContent, 'extensionId');
        const newArray = [];
        // this.props.extensions.forEach(obj1 => {
        //     const obj2 = this.props.vm.runtime._blockInfo.find(obj2 => obj2.id === obj1.extensionId);
        //     if (obj2) {
        //         newArray.push({ ...obj1, ...obj2 });
        //     }
        // });
        // [...this.props.extensions] => newArray
        return newArray
            .map(item => ({
                ...item, ...extensionLibraryThumbnailData[item.extensionId]
            }))
            .filter(v => v);
    }

    setFirmwareMode(data) {
        this.scRef.current.setActiveIndex(data ? data : 'device');
        this.setState({
            selectedValue: data ? data : 'device'
        });
    }

    setVariableMode(data) {
        this.scRef.current.setActiveIndex(data ? data : 'device');
        this.setState({
            selectedValue: data ? data : 'device'
        });
    }

    // handle click
    handleClick = () => {
        const { isShow, onShow, onClose } = this.props;
        if (isShow) {
            onShow(false);
        } else {
            onShow(true);
        }
    };

    // 渲染手柄
    renderDragHandle() {
        return (
            <DrawerHandle
                // isShow={this.props.isShow}
                className="handle"
                onClick={this.handleClick}
            >
                {/* 拖拽的手柄 */}
                <WrapDrawerHandle>
                    <img
                        height="54"
                        width="35"
                        src={this.props.isShow ? handleShowIcon : handleHiddenIcon}
                    />
                </WrapDrawerHandle>
            </DrawerHandle>
        );
    }

    setSelectedValue(data) {
        this.setState({
            selectedValue: data
        });
        this.props.setIsFirmwareUploadMode(!(!data));
        this.scRef.current.setActiveIndex(data);
        this.forceUpdate()
        localStorage.setItem('drawerValue', data)
    }

    render() {
        return (
            <DrawerComponent
                // 抽屉位置右边居中
                position="topRight"
                isShow={this.props.isShow}
                renderDragHandle={this.renderDragHandle}
            >
                <>
                    <SegmentedRadio
                        ref={this.scRef}
                        name="group"
                        callback={this.setSelectedValue}
                    />
                    {/* 展示图像 、设备、变量、python */}
                    {/* {this.state.selectedValue === 'camera' && (
                    <div className="drawerConnect">
                        <CameraComponent 
                            // vm={this.props.vm} 
                        />
                    </div>
                )} */}
                    {this.state.selectedValue === 'device' && (
                        <div className="drawerConnect">
                            <DeviceComponent
                                // vm={this.props.vm}
                                list={this.state.list}
                                deviceState={this.state.deviceState}
                            />
                        </div>
                    )}
                    {this.state.selectedValue === 'monitor' && (
                        <div className="drawerConnect">
                            <MonitorComponent />
                        </div>
                    )}
                    {/* {this.state.selectedValue === 'python' && (<div className="hardware">
                    <Hardware />
                </div>)} */}
                </>
            </DrawerComponent>);
    }
}

MonitorDrawerComponent.propTypes = {
    isShow: PropTypes.bool,
    // onShow: PropTypes.func.isRequired,
    // onClose: PropTypes.func.isRequired,
    // // monitors: PropTypes.objectOf(OrderedMap),
    setIsFirmwareUploadMode: PropTypes.func,
    // // vm: PropTypes.instanceOf(VM).isRequired, // eslint-disable-next-line react/forbid-prop-types
    // extensions: PropTypes.arrayOf(PropTypes.object),
    // isFirmwareMode: PropTypes.bool,
    // intl: intlShape
};

const mapStateToProps = state => ({
    // monitors: state.scratchGui.mataMonitors,
    isShow: state.drawerStore.isShow,
    // isFirmwareMode: state.scratchGui.mode.isFirmwareUpload,
    // extensions: state.scratchGui.extensions.list,
    // isConnected: state.scratchGui.connectionModal.isConnected
});
const mapDispatchToProps = dispatch => ({
    onShow: (state) => dispatch(setDrawerShowState(state)),
    // onClose: () => dispatch(closeMonitorModal()), 
    setIsFirmwareUploadMode: res => dispatch(setIsFirmwareUpload(res))
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MonitorDrawerComponent));
